export enum MoneyBoxType {
  CASH = 'CASH',
  BANK = 'BANK'
}
